/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SourcingSearchCodeWithLabel
 */
export interface SourcingSearchCodeWithLabel {
    /**
     * 
     * @type {string}
     * @memberof SourcingSearchCodeWithLabel
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof SourcingSearchCodeWithLabel
     */
    label: string;
}

/**
 * Check if a given object implements the SourcingSearchCodeWithLabel interface.
 */
export function instanceOfSourcingSearchCodeWithLabel(value: object): value is SourcingSearchCodeWithLabel {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function SourcingSearchCodeWithLabelFromJSON(json: any): SourcingSearchCodeWithLabel {
    return SourcingSearchCodeWithLabelFromJSONTyped(json, false);
}

export function SourcingSearchCodeWithLabelFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourcingSearchCodeWithLabel {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'label': json['label'],
    };
}

export function SourcingSearchCodeWithLabelToJSON(value?: SourcingSearchCodeWithLabel | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'code': value['code'],
        'label': value['label'],
    };
}

